import { SyntheticEvent, useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getBrand, createBrand } from "../../../redux/brandSlice";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dialog, DialogTitle, FormControl, FormControlLabel, IconButton, MenuItem, Radio, RadioGroup, TextField, TextareaAutosize, styled } from "@mui/material";
import React from "react";
import { Brand } from "../../..//model/brand.model";
import { BrandsService } from "../../../service/brands.service";
//import { isNumber } from "lodash";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { ToastContainer, toast } from "react-toastify";
import '../../../../src/App.css';
import { json } from "stream/consumers";
import CloseIcon from '@mui/icons-material/Close';

function SalesRepFeedbackDetails(this: any) {
    const params = useParams();
    const brandId = params.brandid;
    const dispatch = useDispatch();
    const { brand } = useSelector((state: any) => state.brandSlice);
    const navigate = useNavigate();
    const [picture, setPicture] = useState(null);
    const [imgData, setImgData] = useState<string[]>([]);
    const [status, setStatus] = useState(1);
    const [brandName, setBrandName] = useState("");
    const [selectedBrandId, setSelectedBrandId] = React.useState("");
    const [availableBrands, setAvailableBrands] = useState<Brand[]>([]);
    const brandsService = new BrandsService();
    const [selectedVisibility, setSelectedVisibility] = React.useState("");
    const [brandImage, setbrandImage] = useState("");
    const [brandImageData, setbrandImageData] = useState("");
    const [errMsg, setErrMsg] = useState('');
    const [isedit, setIsEdit] = React.useState(false);
    const location = useLocation();

    const [feedbackDetails, setfeedbackDetails] = useState<any>(null);
    const [feedbackImages, setFeedbackImages] = React.useState([]);
    const [feedbackList, setfeedbackList] = React.useState<any>([]);
    const [feedbackText, setfeedbackText] = useState("");
    const [intime, setintime] = useState("");

    const [selectTedimage, setselectTedimage] = useState("");
    const [showimageDlg, setshowimageDlg] = useState(false);

    const myComponent = {
        backgroundColor: "#F2F2F3",
        height: '150px',


    };

    const imgComponent = {
        height: '25px'
        // display: inline-block

    };


    let iscalled = false;
    useEffect(() => {
        //console.log("+++++++++++++++selectedBradId : " + selectedBrandId)
        if (!iscalled) {
            iscalled = true


            if (location != null && location.state != null && location.state.feedbackDetails != null) {

                setfeedbackDetails(location.state.feedbackDetails)
                // {"sNo":1,"entId":41,"salesRepId":8,"createdDate":"2024-05-04 02:18:09.000000","salesfeedback":{"intime":"04/05/2024 02:15 AM","outtime":"04/05/2024 02:15 AM","remarks":[{"info":"Iffu"}],"imgFiles":[]},"id":1,"action":1}
                console.log("params ", JSON.stringify(location.state.feedbackDetails))

                setFeedbackImages(location.state.feedbackDetails.salesfeedback.imgFiles)




                setfeedbackList(location.state.feedbackDetails.salesfeedback.remarks)

             //   setfeedbackList([{"info":"Iffu"},{"info":"Iffu"},{"info":"Iff"},{"info":"Iffu"}])

             
                //feedbackText
                var feedbktxt = ""
                location.state.feedbackDetails.salesfeedback.remarks.map((item: any, index: number) => {
                    feedbktxt = feedbktxt + "\n" + item.info
                })

                setfeedbackText(feedbktxt)
                setintime(location.state.feedbackDetails.salesfeedback.intime)
                setSelectedBrandId(location.state.feedbackDetails.brandId)
                setBrandName(location.state.feedbackDetails.brandName)
                //setbrandImage(((location.state.brandDetails.brandImage).split("/").pop()))
                //setStatus(location.state.feedbackDetails.status)
                //setIsEdit(false)
                // setSelectedVisibility(location.state.feedbackDetails.visibility)

            }
        }
    }, []);

    const onChangePicture = (e: any) => {
        if (e.target.files[0]) {
            setPicture(e.target.files[0]);
            // setImgData(URL.createObjectURL(e.target.files[0]));
        }
    };


    const [submitClick, setsubmitClick] = React.useState(false);
    const createNewBrand = () => {

        if (brandName == "" || brandName == null || brandImage == "" || brandImage == null || selectedVisibility == null) {
            setsubmitClick(true)
            return
        }

        const data = {
            "brandId": selectedBrandId,
            "status": status,
            "brandName": brandName,
            "brandImage": brandImage,
            "brandImageData": brandImageData,
            "visibility": selectedVisibility
        };
        brandsService.createBrand(data).then((res: any) => {
            if (res.status == '100') {

                toast.success("Updated Successfully !!!", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 2000,
                    hideProgressBar: true,
                });
                setTimeout(() => {
                    navigate('../brands');
                }, 2100);

            } else {
                toast.error("No Data Available!!!", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 2000,
                    hideProgressBar: true,
                });
                setTimeout(() => {
                    navigate('../brands');
                }, 2100);
            }
        })
    };

    const onUploadBrandImg = (event: SyntheticEvent) => {
        const element = event.target as HTMLInputElement;
        if (element.files) {

            const file = element.files[0];
            console.log("^^^Cad^^^^^^^^^^^file : " + file.name);
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => {

                setbrandImage(file.name);

                setbrandImageData(reader.result as string);

            }
            reader.onerror = (e) => { console.log('err') }
        }
    }


    
    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
        },
    }));

    interface DialogTitleProps {
        id: string;
        children?: React.ReactNode;
        onClose: () => void;
    }

    function BootstrapDialogTitle(props: DialogTitleProps) {
        const { children, onClose, ...other } = props;

        return (
            <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
                {children}
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
        );
    }

    return (
        <div className="App">
            <div className="card m-8">

                <div className="card-body ">

                    <div className="row pt-4">


                        {feedbackDetails && <div className="col-md-6 text-left">
                            <div className="form-group  font_size_13px">

                                <TextField size="small" label="SalesRep Name" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 } }}
                                    type="text" className="form-control" name='prodDispName' value={feedbackDetails.salesRepName}
                                    error={submitClick && (brandName == "" || brandName == null)}
                                    //  helperText={ (submitClick &&   (brandName == "" || brandName == null)) ? 'required*' : ""}

                                    disabled={!isedit}
                                    onChange={(e: any) => {

                                    }}
                                />
                            </div>
                        </div>}


                        {feedbackDetails && <div className="col-md-6 text-left">
                            <div className="form-group  font_size_13px">

                                <TextField size="small" label="Enterprise Name" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 } }}
                                    type="text" className="form-control" name='prodDispName' value={feedbackDetails.entName}
                                    error={submitClick && (brandName == "" || brandName == null)}
                                    //  helperText={ (submitClick &&   (brandName == "" || brandName == null)) ? 'required*' : ""}

                                    disabled={!isedit}
                                    onChange={(e: any) => {
                                        setBrandName(e.target.value)
                                    }}
                                />
                            </div>
                        </div>}


                        {feedbackDetails && <div className="col-md-6 text-left">
                            <div className="form-group  font_size_13px">

                                <TextField size="small" label="In Time" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 } }}
                                    type="text" className="form-control" name='prodDispName' value={feedbackDetails.salesfeedback.intime}
                                    // defaultValue={intime}
                                    error={submitClick && (brandName == "" || brandName == null)}
                                    //  helperText={ (submitClick &&   (brandName == "" || brandName == null)) ? 'required*' : ""}

                                    disabled={!isedit}
                                    onChange={(e: any) => {
                                        //setintime(e.target.value)
                                        //setBrandName(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                        }

                        {feedbackDetails && <div className="col-md-6 text-left">
                            <div className="form-group  font_size_13px">

                                <TextField size="small" label="Out Time" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 } }}
                                    type="text" className="form-control" name='prodDispName' value={feedbackDetails.salesfeedback.outtime}
                                    error={submitClick && (brandName == "" || brandName == null)}
                                    //  helperText={ (submitClick &&   (brandName == "" || brandName == null)) ? 'required*' : ""}

                                    disabled={!isedit}
                                    onChange={(e: any) => {
                                        // setBrandName(e.target.value)
                                    }}
                                />
                            </div>

                        </div>
                        }
                        <div className='col-md-12 text-left'>

                            <div className="form-group border m:0">

                                <div style={{ height: '120px' }}   >

                                    {/* To List File */}
                                    <div className="row ml-0 mr-0 p-1 scollxdirection" style={myComponent}>
                                        {feedbackImages && feedbackImages
                                            .map((item: any, index: number) => {
                                                return (
                                                    <tr key={index} className="m-0 text-center pl-0"  >
                                                        { }
                                                        <td>
                                                            <img src={item.filename} width="120" height="120"  onClick={()=>{
                                                                setselectTedimage(item.filename)
                                                                setshowimageDlg(true)
                                                            }}/>

                                                        </td>
                                                    </tr>
                                                );
                                            })}



                                    </div>

                                </div>


                            </div>
                        </div>


                   

                        <div className='col-md-12 ' style={{height:30}}/>
                     



                      <div className='col-md-12 '>

                        <div className="form-group border m:0">

                            <div style={{ height: '140px' }}   >

                                {/* To List File */}
                                <div className="row ml-0 mr-0 p-1 scollxdirection" style={myComponent}>
                                <ul  className="m-0  pl-0" style={{width:'100%',textAlign:'left' ,whiteSpace:'pre-wrap'}}  >
                                    {feedbackList && feedbackList
                                        .map((item: any, index: number) => {
                                            return (  
                                                    <li>{(index+1)+ ") "+  item.info }</li>                                              
                                               
                                            );
                                        })}

                                   </ul>

                                </div>

                            </div>


                        </div>
                        </div>




                    </div>
                </div>
                <div className="card-footer col-12 text-center">

                    <Button style={{ color: "red" }} className="ml-4" onClick={() => navigate('../salesfeedbacklist')} variant="text" startIcon={<ClearOutlinedIcon />}>
                        Cancel
                    </Button>
                </div>
            </div>

            <ToastContainer />


            
            <BootstrapDialog
                    fullWidth                    
                    onClose={()=>{
                        setshowimageDlg(false)
                        setselectTedimage("")

                    }}
                    aria-labelledby="customized-dialog-title"
                    open={showimageDlg}>

                    <BootstrapDialogTitle id="customized-dialog-title" onClose={()=>{
                        setshowimageDlg(false)
                        setselectTedimage("")
                    }}>
                       
                    </BootstrapDialogTitle>

                     <br></br>   
                    {selectTedimage}     
            <img 
            
            
            src={selectTedimage} 
            width="100%" height="100%" />

                   
                   
                </BootstrapDialog>

        

        </div>
    );
}

export default SalesRepFeedbackDetails;
